module.exports = __webpack_public_path__ + "static/img/bg.5e9c6a46.jpg";